import React, { useEffect } from 'react';
//router
import IndexRouters from './router/index';
//scss
import './assets/scss/hope-ui.scss';
import './assets/scss/dark.scss';
import './assets/scss/rtl.scss';
import './assets/scss/custom.scss';
import './assets/scss/customizer.scss';
//Importing Interceptor
import './services/interceptors';
//recoil
import { useRecoilValue } from 'recoil';
import { userSelector } from './recoil/auth/selector';

// Adds Role based access control
import { AbilityContext } from './config/acl/can';
import ability from './config/acl/ability';

import { OpenReplayService } from './services/openreplay-service';
const isProduction = process.env.REACT_APP_STAGE === 'production';

const tracker = isProduction ? new OpenReplayService() : null;
function App() {
  const user = useRecoilValue(userSelector);
  useEffect(() => {
    if (isProduction) {
      tracker.start();
    }
  }, []);

  useEffect(() => {
    if (user && user.email && isProduction) {
      tracker.setUserData({
        email: user.email,
        userFullName: user.userFullName,
      });
    }
  }, [user]);

  return (
    <AbilityContext.Provider value={ability(user)}>
      <div className="App">
        <IndexRouters />
      </div>
    </AbilityContext.Provider>
  );
}

export default App;
